  <div class="container-fluid">
    <div class="row mh-100vh" #divLoginPage>
      <div class="col-10 col-sm-8 col-md-6 col-lg-6 offset-1 offset-sm-2 offset-md-3 offset-lg-0 align-self-center d-lg-flex align-items-lg-center align-self-lg-stretch bg-white p-5 rounded rounded-lg-0 my-5 my-lg-0" id="login-block">
        <div class="m-auto register-login w-lg-75 w-xl-50">
          <div class="text-center mb-5"><img class="login-logo" src="assets/images/CFN-LOGO-Validated.svg" style="max-width: 200px;"></div>
          <h2 class="text-center" style="font-size: 20px;line-height: 1.5;margin: 20px auto;">S'authentifier<br></h2>
          <form method="post" [formGroup]="loginForm" (ngSubmit)="handleValidSubmit($event)" action="#" novalidate>
            <div class="alert alert-danger" *ngIf="submitted && loginError">
              Login ou mot de passe incorrect.
            </div>
            <div class="form-group">
              <input class="form-control" type="email" name="Email" formControlName="Email"
                     placeholder="Email" [ngClass]="{ 'is-invalid': submitted && f.Email.errors }">
              <div *ngIf="submitted && f.Email.errors" class="text-danger invalid-feedback">
                <div *ngIf="f.Email.errors.required">Email obligatoire.</div>
                <div *ngIf="f.Email.errors.maxlength">Maximum 100 caractères.</div>
                <div *ngIf="f.Email.errors.pattern">Format invalide.</div>
              </div>
            </div>
            <div class="form-group">
              <input class="form-control" type="password" name="Password"
                     formControlName="Password" placeholder="Mot de passe"
                     [ngClass]="{ 'is-invalid': submitted && f.Password.errors }">
              <div *ngIf="submitted && f.Password.errors" class="text-danger invalid-feedback"
                   style="font-size: 80%; color: #dc3545;">
                <div *ngIf="f.Password.errors.required">Mot de passe obligatoire.</div>
                <div *ngIf="f.Password.errors.pattern">Format invalide.</div>
              </div>
            </div>
            <div class="form-group">
              <div class="form-check">
                <label class="form-check-label" style="font-size: 13px;line-height: 20px;">
                  <input class="form-check-input" formControlName="RememberMe" name="rememberMe"
                         type="checkbox">Se souvenir de moi<br>
                </label>
              </div>
            </div>
            <div class="form-group">
            <button class="btn btn-primary btn-block" type="submit" (click)="handleValidSubmit($event)">
              <i class="pi pi-unlock"></i>Se connecter
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm" style="color:white;" role="status"
                    aria-hidden="true"></span>
            </button></div>
            <a class="lien01"  href="/lostPassword">Mot de passe oublié ?</a>
          </form>
        </div>
      </div>
      <div class="col-lg-6 d-flex align-items-end login-bg" id="bg-block">
        <div></div>
      </div>
    </div>
  </div>
